import { computed, ref, unref } from '@nuxtjs/composition-api'
import { Context } from '@nuxt/types'
import { MaybeRef } from '@vueuse/core'

import SearchFilter from '@/classes/SearchFilter'

export default function () {
  const filter = ref(new SearchFilter())

  const setSearchFilterFromQuery = (query: MaybeRef<Context['query']>) => {
    filter.value = SearchFilter.fromQueryObject(unref(query))
  }

  const sortMethod = computed({
    get: () => filter.value.sortMethod,
    set (value) {
      const filterClone = filter.value.clone()
      filterClone.setSortMethod(value)
      filter.value = filterClone
    },
  })

  const ageRange = computed({
    get: () => filter.value.ageRange,
    set (value) {
      filter.value.setAgeRange(value)
      update()
    },
  })

  const priceRange = computed({
    get: () => filter.value.priceRange,
    set (value) {
      filter.value.setPriceRange(value)
      update()
    },
  })

  const oneWayRental = computed({
    get: () => filter.value.oneWayRental,
    set (value) {
      filter.value.setOneWayRental(value)
      update()
    },
  })

  const acceptForeigner = computed({
    get: () => filter.value.acceptForeigner,
    set (value) {
      filter.value.setAcceptForeigner(value)
      update()
    },
  })

  const brands = computed({
    get: () => filter.value.brands,
    set (value) {
      filter.value.setBrands(value)
      update()
    },
  })

  const carTypes = computed({
    get: () => filter.value.carTypes,
    set (value) {
      filter.value.setCarTypes(value)
      update()
    },
  })

  const paymentMethods = computed({
    get: () => filter.value.paymentMethods,
    set (value) {
      filter.value.setPaymentMethods(value)
      update()
    },
  })

  const storeServices = computed({
    get: () => filter.value.storeServices,
    set (value) {
      filter.value.setStoreServices(value)
      update()
    },
  })

  const equipments = computed({
    get: () => filter.value.equipments,
    set (value) {
      filter.value.setEquipments(value)
      update()
    },
  })

  /** 透過深度克隆自己來強制更新 `filter` */
  const update = () => {
    filter.value = filter.value.clone()
  }

  /** 清除所有篩選條件 */
  const clear = () => {
    filter.value.clear()
    update()
  }

  /** 取得兩組數字區間的交集 */
  const getIntersection = (
    a: readonly [number, number],
    b: readonly [number, number]
  ): [number, number] | undefined => {
    const min = (a[0] < b[0]) ? a : b
    const max = (min === a) ? b : a
    if (min[1] < max[0]) return
    return [max[0], (min[1] < max[1]) ? min[1] : max[1]]
  }

  /** 修正價格範圍在允許的區間範圍之外或交集的情況 */
  const normalizePriceRange = (priceRangeMinMax: readonly [number, number]) => {
    if (!priceRange.value) return
    priceRange.value = getIntersection(priceRange.value, priceRangeMinMax)
  }

  return {
    filter,
    setSearchFilterFromQuery,

    sortMethod,
    ageRange,
    priceRange,
    oneWayRental,
    acceptForeigner,
    brands,
    carTypes,
    paymentMethods,
    storeServices,
    equipments,

    clear,
    normalizePriceRange,
  }
}
